<template>
    <div style="display: flex;flex-direction: column;text-align: center;padding:22px;">
        <div style="font-size: 12px;color: #0F1A3A;">{{ title }}</div>
        <el-tooltip :content="value" placement="top">
            <div
                style="color: #0F1A3A;font-size: 24px;font-weight: bold;margin-top: 14px;margin-bottom: 8px;max-width: 150px;overflow: hidden;">
                {{ value }}</div>
        </el-tooltip>
        <div style="font-size: 12px;color: #0F1A3A;">{{ unit }}</div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number],

            default: ''
        },
        unit: {
            type: String,
            default: ''
        }
    }
}
</script>
